<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <div class="col-xl-12">
                            <h5 v-show="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>                                         
                                Nenhum resultado encontrado.
                            </h5>
                        </div>
                     
                        <div class="col-xl-12">

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px">
                                            Id
                                        </th>   
                                        <th style="min-width: 200px;">
                                            Solicitado por
                                        </th>                                        
                                        <th style="min-width: 120px; width: 120px;">
                                            Liberado para
                                        </th>
                                        <th style="min-width: 120px; width: 120px;">
                                            Duração
                                        </th>                                        
                                        <th style="min-width: 100px; width: 100px;">
                                            Solicitado em    
                                        </th>            
                                        <th style="min-width: 100px; width: 100px;">
                                            Permitido em    
                                        </th>                                                                                
                                        <th style="min-width: 120px; width: 120px;">
                                            Ações
                                        </th>                                                                     
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.cod">
                                            <td data-label="">
                                                <a >
                                                    <span class="hidden-xl hidden-lg">Id: </span>{{item.id}}
                                                </a>
                                            </td>
                                            <td data-label="Usuário">
                                                <a >
                                                    {{item.usuario ? item.usuario.nome : '-'}}
                                                </a>
                                            </td>                 
                                            <td data-label="Tipo da permissão">
                                                <a v-if="!item.usuarioCod">
                                                    Todos os profissionais
                                                </a>
                                                <a v-if="item.usuarioCod">
                                                    Somente esse profissional
                                                </a>                                                
                                            </td>  
                                            <td data-label="Duração">
                                                <a v-if="item.tempo == 'sempre'">
                                                    Sempre
                                                </a>
                                                <a v-if="item.tempo == '24h'">
                                                    24 horas
                                                </a>
                                                <a v-if="item.tempo == '6m'">
                                                    6 meses
                                                </a>                                                                                                
                                            </td>    
                                            <td data-label="Solicitado em">    
                                                {{item.datahora | formatDate}}
                                            </td>
                                            <td data-label="Permitido em">    
                                                {{item.atualizacao | formatDate}}
                                            </td>                                                                                                                                    
                                            <td data-label="Ações" class="" style="text-align: center">
                                                <a class="dashboard-status-button red" v-on:click="del(item.cod)">
                                                    <i class="las la-trash" style="top: 1px"></i>
                                                    Remover
                                                </a>                                                  
                                            </td>                                                                                                                                        
                                        </tr>                                                                      
                                        
                                    </tbody>
                                </table>                            
                            </div>                                               
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'PermissaoUsoDados',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {         
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja remover esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/uso-de-dados.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    Promise.all([
                        self.get()
                    ]).then(function() {
                    
                        self.$forceUpdate();
                        loading.hide();
                        
                    }).catch(function(error) {
                        loading.hide();
                    });  
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },            
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_PESSOA_FISICA":   self.$route.query.CD_PESSOA_FISICA ? self.$route.query.CD_PESSOA_FISICA : null
                    }
                };

                axios.get("api/uso-de-dados.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data      = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
    }
    .dashboard-status-button i {
        color: #fff;
        top: -3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/PermissaoUsoDados.vue